"use strict";

exports.__esModule = true;
exports.PlantGridThumbnail = PlantGridThumbnail;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Thumbnail for DeviceGridWidget.
 */
function PlantGridThumbnail(props) {
  var _props$x = props.x,
    x = _props$x === void 0 ? 0 : _props$x,
    _props$y = props.y,
    y = _props$y === void 0 ? 0 : _props$y,
    width = props.width,
    height = props.height,
    _props$itemWidth = props.itemWidth,
    itemWidth = _props$itemWidth === void 0 ? 250 : _props$itemWidth,
    _props$itemHeight = props.itemHeight,
    itemHeight = _props$itemHeight === void 0 ? 250 : _props$itemHeight,
    _props$rowGutter = props.rowGutter,
    rowGutter = _props$rowGutter === void 0 ? 16 : _props$rowGutter,
    _props$columnGutter = props.columnGutter,
    columnGutter = _props$columnGutter === void 0 ? 16 : _props$columnGutter,
    render = props.render,
    children = props.children;
  var itemsPerRow = Math.floor(width / (itemWidth + columnGutter)) || 1;
  var visibleRowCount = Math.ceil(height / (itemHeight + rowGutter)) || 1;
  var availableWidth = width - (itemsPerRow - 1) * columnGutter;
  var flexItemWidth = availableWidth / itemsPerRow;
  var cells = [];
  var top = 0;
  for (var rowIndex = 0; rowIndex < visibleRowCount; rowIndex++) {
    var left = 0;
    for (var columnIndex = 0; columnIndex < itemsPerRow; columnIndex++) {
      cells.push(/*#__PURE__*/_react["default"].createElement("svg", {
        x: left,
        y: top,
        key: rowIndex + ":" + columnIndex,
        width: flexItemWidth,
        height: itemHeight
      }, /*#__PURE__*/_react["default"].createElement("rect", {
        width: flexItemWidth,
        height: itemHeight,
        fill: "white"
      }), render(children.map(function (child) {
        return Object.assign({}, child, {
          props: Object.assign({}, child.props, {
            width: flexItemWidth,
            height: itemHeight
          })
        });
      }))));
      left += flexItemWidth + columnGutter;
    }
    top += rowGutter + itemHeight;
  }
  return /*#__PURE__*/_react["default"].createElement("svg", {
    x: x,
    y: y,
    width: width,
    height: height
  }, cells);
}